module.exports = __webpack_public_path__ + "static/UploadAdmin-78527580c4b4bac7201ffcead2d408ba.png";